module.exports = __webpack_public_path__ + "static/media/et.a61da8e2.svg";